import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import {
  LoyaltyCategoryType,
  Scorecard,
  ScorecardCustomerPrizeOptionItemModel,
  ScorecardDescription,
  ScorecardService,
} from '@fgb/core';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'fgbcl-scorecard-description-linked-action',
  templateUrl: './scorecard-description-linked-action.component.html',
  styleUrl: './scorecard-description-linked-action.component.scss',
})
export class ScorecardDescriptionLinkedActionComponent implements OnChanges {
  @Input() scorecardDescription: ScorecardDescription;
  @Output() onNextClick: EventEmitter<any> = new EventEmitter();
  @Output() onPrevious: EventEmitter<any> = new EventEmitter();

  myContext: any;
  loyaltyCategoryType = LoyaltyCategoryType.Scorecard;

  constructor(private scorecardService: ScorecardService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.scorecardDescription) {
      this.getContextForNextChallenge();
    }
  }

  get hasPrizeSelection(): boolean {
    return !!this.scorecardDescription.currentScorecard?.PrizeOptions;
  }

  get isLastChildUnlocked(): boolean {
    return this.scorecardDescription.hasParent && !this.scorecardDescription.hasChild && !this.scorecardDescription.isLocked;
  }

  get scorecardCompletedNotSelectPrize(): boolean {
    return (
      this.scorecardDescription.isCompleted &&
      this.scorecardDescription.currentScorecard.PrizeOptions?.CustomerHasSelected == false
    );
  }
  //Return name of prize has selected = true
  get prizeSelected(): string | undefined {
    if (
      this.scorecardDescription.currentScorecard?.PrizeOptions &&
      Object.keys(this.scorecardDescription.currentScorecard?.PrizeOptions).length == 0
    )
      return '';
    let prizeSelected = this.scorecardDescription.currentScorecard?.PrizeOptions?.Prizes.find((prize) => prize.Selected);
    return prizeSelected?.PrizeTitle;
  }

  onPrizeConfirmed(prize: ScorecardCustomerPrizeOptionItemModel) {
    firstValueFrom(this.scorecardService.selectPrize(prize.ScorecardId, prize.PrizeId));
  }
  getContextForNextChallenge() {
    // Completed scorecard have child
    if (this.scorecardDescription.isCompleted && this.scorecardDescription.hasChild) {
      this.createContext(this.scorecardDescription.childScoreCard, 'scorecard.description.next.challenge', true, true);
    }

    // Incompleted scorecard have child
    if (!this.scorecardDescription.isCompleted && !this.scorecardDescription.isLocked && this.scorecardDescription.hasChild) {
      this.createContext(this.scorecardDescription.childScoreCard, 'scorecard.description.next.challenge', false, true);
    }

    // Child scorecard has been locked
    if (this.scorecardDescription.hasParent && this.scorecardDescription.isLocked) {
      this.createContext(this.scorecardDescription.parentScorecard, 'scorecard.description.complete.first', true, false);
    }
    // scorecard has been locked and has parent locked
    if (
      this.scorecardDescription.hasParent &&
      this.scorecardDescription.parentScorecard.Locked &&
      this.scorecardDescription.isLocked
    ) {
      this.createContext(this.scorecardDescription.parentScorecard, 'scorecard.description.complete.first', false, false);
    }
  }

  createContext(scorecard: Scorecard, label: string, invisibleIcon: boolean, isDirectToChild: boolean) {
    let image = scorecard?.Image;
    let name = scorecard?.Content[0].Name;
    let description = scorecard?.Content[0].ShortDescription;
    let isCompleted = scorecard.Completed;
    this.myContext = {
      label: label,
      image: image,
      name: name,
      invisibleIcon: invisibleIcon,
      description: description,
      isCompleted: isCompleted,
      redirectScorecard: () => this.redirectScorecard(isDirectToChild),
    };
  }

  redirectScorecard(isDirectToChild: boolean) {
    if (isDirectToChild) {
      return this.onNextClick.emit();
    }
    if (!isDirectToChild) {
      return this.onPrevious.emit();
    }
  }
}
